'use client';

import { motion } from 'framer-motion';
import Illustration4 from '@/app/components/vectors/Illustration4';


// Entrance (slide + scale in) handed off into a continuous gentle float once
// settled — Illustration2 already fades its own strokes in via whileInView,
// so this wrapper only owns position/scale.
export default function FloatingBrandIcon({ className = '' }: { className?: string }) {
    return (
        <motion.div
            initial={{ y: -22, scale: 0.8 }}
            animate={{ y: [0, -10, 0], scale: 1 }}
            transition={{
                scale: { duration: 0.7, ease: 'easeOut' },
                y: { duration: 3.2, repeat: Infinity, ease: 'easeInOut', delay: 0.7 },
            }}
            className={className}
        >
            <Illustration4 className="h-full w-full drop-shadow-[0_14px_30px_rgba(0,0,0,0.35)]" />
        </motion.div>
    );
}
